
/**
 * Check color contrast
 * @param hexcolor
 * @returns {boolean} true for black, false for white
 */
export const getContrastYIQ = (hexcolor) => {
  if (hexcolor.length === 4) {
    hexcolor = `${hexcolor.substr(1, 1)}${hexcolor.substr(1, 1)}${hexcolor.substr(2, 1)}${hexcolor.substr(2, 1)}${hexcolor.substr(3, 1)}${hexcolor.substr(3, 1)}`;
  }

  const r = parseInt(hexcolor.substr(1, 2), 16);
  const g = parseInt(hexcolor.substr(3, 2), 16);
  const b = parseInt(hexcolor.substr(5, 2), 16);
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return yiq >= 128;
};

export const rgbToHex = (r, g, b) => `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;

export const hexToRgb = (hex) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  } : null;
};

/**
 * Find parent node by class
 * @param el
 * @param klass
 * @returns {*}
 */
export const findAncestor = (el, klass) => {
  el = el.parentElement;

  while (el && !el.classList.contains(klass)) {
    el = el.parentElement;
  }

  return el;
};

/**
 * animate scroll
 * @param element
 * @param to
 * @param duration
 */
export const scrollTo = (element, to, duration) => {
  if (duration <= 0) return;
  const difference = to - element.scrollTop;
  const perTick = (difference / duration) * 10;

  const step = () => {
    element.scrollTop += perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  };

  window.requestAnimationFrame(step);
};

/**
 * For Sample UI page only
 * @returns {number}
 */
export const getNumberOfSamplePerRow = () => {
  const width = window.innerWidth;

  if (width <= 767) return 1;

  if (width <= 990) return 2;

  if (width <= 1200) return 3;

  if (width <= 1800) return 4;

  if (width <= 1920) return 5;

  if (width <= 2500) return 6;

  if (width <= 3200) return 7;

  return 9;
};

/**
 * Remove any element's focus
 */
export const removeFocus = () => {
  window.focus();
  if (document.activeElement) {
    document.activeElement.blur();
  }
};

export const key = {
  SHIFT: 16,
  TAB: 9,
  LEFT: 37,
  RIGHT: 39,
  SPACE: 32,
  ENTER: 13,
  ESC: 27,
  UP: 38,
  DOWN: 40,
  N2: 50,
  N3: 51,
  N4: 52,
  N5: 53,
  C: 67,
  D: 68,
  E: 69,
  P: 80,
  S: 83,
};

export const MAXIMUM_COLOR_PALETTES = 15;

function generateColor() {
  let color = '';

  while (color.length < 6) {
    color += (Math.random()).toString(16).substr(-6).substr(-1);
  }

  return color;
}

export function validateHex(colors) {
  colors = colors.split('-').map(t => {
    if (/^[A-Fa-f0-9]{6}$/.test(t)) {
      return t;
    }

    return generateColor();
  });

  while (colors.length < 2) {
    colors.push(generateColor());
  }

  if (colors.length > 5) {
    colors.splice(5);
  }

  return colors;
}

export function downloadBlob(blob, name) {
  const ele = document.createElement('a');
  const url = URL.createObjectURL(blob);

  ele.src = url;
  ele.download = name;

  ele.click();
}
